'use client'
import React from 'react'
import { Hero, Footer } from '../../../components'
import styles from './cookiepolicy.module.css'

const CookiePolicy = () => {
  return (
    <div className={styles.cookiescontainer}>
      <Hero className={styles.innercontent}>
        <button className={styles.herobtn}>our cookie policy</button>
        <p className={styles.herotitle}>CirclePlug Cookie Policy</p>
        <p className={styles.herodescription}>
          We care about your privacy Your privacy is important to us 
        </p>
      </Hero>
      <div className={styles.maincontentcontainer}>
        <div>
          <div className={styles.maincontentcontainerwrapper}>
            <div className={styles.termsofservicemaincontent}>
              <div className={styles.termsofservicemaincontenttop}>
                <p>Our Cookie Policy</p>
                <p>
                  {`CIRCLEPLUG respects your privacy and is committed to providing
                  you with the information and tools you need to manage your
                  cookies. A cookie is a small file of letters and numbers that
                  we store on your browser or the hard drive of your computer if
                  you agree. Cookies contain information that is transferred to
                  your computer's hard drive. ; disabling these will prevent you
                  from accessing our platform as well as other important
                  sections of our website. These cookies make it easier for you
                  to find and access the information you need, and also allows
                  us to tailor our website content to suit your preferences. We
                  may use cookies to help identify your computer so we can track
                  website usage and adapt your user experience. You may disable
                  or modify any cookies already stored on your computer, but
                  these may prevent our website from functioning properly. It is
                  recommended you enable ‘cookies acceptance’ in order to
                  benefit from all the features and services our website has to
                  offer. In doing so, you also agree for us to share your
                  personal information with third parties for the above stated
                  purposes. We may also use the information for analysis in
                  order to improve our products and services in line with our
                  Privacy Policy. Furthermore, HYCM may use external service
                  providers to track the traffic and usage of our website.`}
                </p>
              </div>
              <div className={styles.termsofservicemaincontenttop}>
                <p>We use the following Cookies</p>
                <p>
                  <span className={styles.cookiesbold}>Login Cookies:</span> {' '}
                  {`Login Cookie Allows us to maintain a logged in users
                  session. This is a standard session Cookie.`}
                  <br />{' '}
                  {`Strictly necessary Cookies. These are cookies that are
                  required for the operation of our website. They include, for
                  example, cookies that enable you to log into secure areas of
                  our website, use a shopping cart or make use of e- billing
                  services.`}
                  <br />{' '}
                  {`Analytical/performance Cookies. They allow us to
                  recognize and count the number of visitors and to see how
                  visitors move around our website when they are using it. This
                  helps us to improve the way our website works, for example, by
                  ensuring that users are finding what they are looking for
                  easily. Please note that third parties (including, for
                  example, Google Analytics and providers of external services
                  like web traffic analysis services) may also use cookies, over
                  which we have no control. These cookies are likely to be
                  analytical/performance cookies or targeting cookies. You block
                  cookies by activating the setting on your browser that allows
                  you to refuse the setting.`}
                  <br />
                  <span className={styles.cookiesbold}>
                    Functionality Cookies:
                  </span>
                  {` `}
                  {`These are used to recognize you when you return to our
                  website. This enables us to personalise our content for you,
                  greet you by name and remember your preferences (for example,
                  your choice of language or region).  Targeting Cookies: These
                  cookies record your visit to our website, the pages you have
                  visited and the links you have followed. We will use this
                  information to make our website and the advertising displayed
                  on it more relevant to your interests. We may also share this
                  information with third parties for this purpose. You can find
                  more information about the individual cookies we use and the
                  purposes for which we use them in the table below:`}
                </p>
              </div>
            </div>
          </div>

          <div className={styles.emptycontent}></div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  )
}

export default CookiePolicy
